import React from "react";
import { GenericSignal, SignalType } from "@types";
import { BrandIcon } from "@taskpane/icons";
import css from "./WelcomeSignalContent.module.scss";
import { useAppSelector } from "@store";

export interface WelcomeSignalContentProps {
  signal: GenericSignal<SignalType.Welcome | SignalType.WelcomeBack>;
}

const WelcomeSignalContent: React.FC<WelcomeSignalContentProps> = ({ signal }) => {
  const user = useAppSelector((state) => state.auth.user);

  const title =
    signal.eventName === SignalType.Welcome
      ? `Welcome, ${user?.name || "User"}!`
      : `Welcome back, ${user?.name || "User"}!`;

  const attrs = {
    container: {
      className: css.container,
    },
    icon: {
      className: css.icon,
    },
  };

  return (
    <div {...attrs.container}>
      <span>{title}</span>
      <BrandIcon {...attrs.icon} />
    </div>
  );
};

export default WelcomeSignalContent;
